import { forwardRef } from "react";

import type { Address, LocationServiceAutocompleteService } from "@jti/fe-common";

import type { TextInputProps } from "../Inputs";
import { TextInput } from "../Inputs";

import { DaumPlaceInput, GooglePlaceInput, YandexPlaceInput } from "./components";

export type PlaceInputResults = Pick<
  Address,
  "city" | "postcode" | "provinceName" | "regionCode" | "districtName" | "streetName" | "streetNumber"
> & {
  singleFieldAddress?: string;
};

export type PlaceInputProps = {
  onPlace?: (result: PlaceInputResults) => void;
  autocompleteProvider?: LocationServiceAutocompleteService;
  labelId?: string;
} & TextInputProps;

export const PlaceInput = forwardRef<HTMLInputElement, PlaceInputProps>(
  ({ onPlace, autocompleteProvider = "google", ...props }, ref) => {
    if (autocompleteProvider === "none") {
      return <TextInput {...props} ref={ref} />;
    }
    if (autocompleteProvider === "daum") {
      return <DaumPlaceInput onPlace={onPlace} {...props} ref={ref} />;
    }
    if (autocompleteProvider === "yandex") {
      return <YandexPlaceInput onPlace={onPlace} {...props} ref={ref} />;
    }

    return <GooglePlaceInput onPlace={onPlace} {...props} ref={ref} />;
  }
);
